export default process.env.NEXT_PUBLIC_API_URL ? process.env.NEXT_PUBLIC_API_URL : 'https://jdiyield.com'

export const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL
  ? process.env.NEXT_PUBLIC_BACKEND_URL
  : `https://api.jdiyield.com`

export const cmsUrl = process.env.NEXT_PUBLIC_CMS_URL
